var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingBusinesscard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    fill: "none",
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52 104c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7209B7",
    fillRule: "evenodd",
    d: "M74.57 30.333H29.43c-3.484 0-6.319 2.835-6.319 6.32v32.5c0 3.484 2.835 6.32 6.32 6.32H74.57c3.484 0 6.32-2.836 6.32-6.32v-32.5c0-3.485-2.836-6.32-6.32-6.32zm-32.952 8.125c3.738 0 6.771 3.034 6.771 6.771 0 3.738-3.033 6.77-6.77 6.77-3.738 0-6.772-3.032-6.772-6.77 0-3.737 3.034-6.77 6.771-6.77zm9.39 28.89H32.265c-1.613 0-2.925-1.415-2.69-3.088.848-5.959 6.03-10.455 12.06-10.455 6.013 0 11.195 4.496 12.043 10.455.237 1.69-1.103 3.087-2.672 3.087zm14.534-9.931h-6.32c-1.498 0-2.708-1.21-2.708-2.709 0-1.498 1.21-2.708 2.708-2.708h6.32c1.498 0 2.708 1.21 2.708 2.708 0 1.499-1.21 2.709-2.708 2.709zm6.32-8.125h-12.64c-1.498 0-2.708-1.21-2.708-2.709 0-1.498 1.21-2.708 2.708-2.708h12.64c1.498 0 2.708 1.21 2.708 2.708 0 1.499-1.21 2.709-2.709 2.709z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingBusinesscard);
export default __webpack_public_path__ + "static/media/marketing-businesscard.2a33d6d98bff49ce333daf4e3587ae9f.svg";
export { ForwardRef as ReactComponent };